import { Loader } from '@googlemaps/js-api-loader'
import('../../services/google-maps-optimizer.js')

const googleMapsApi = new Loader({
  apiKey: GOOGLE_MAPS_API_KEY,
  version: '3.exp',
  libraries: ['places'],
})

googleMapsApi.load().then((google) => {
  Promise.all([import('./tab-park-info.scss'), import('../kentico-form/kentico-form')]).then(() => {
    $('.widget.tab-park-info').each(function (i, el) {
      $(el).data('widget', new TabParkInfo(el, google))
      $(el).data('widget').init()
    })
  })
})

function TabParkInfo(el, google) {
  const self = this
  self.el = $(el)
  self.formContainer = self.el.find('.form-container')
  self.optimizer = window.googleMapsOptimizer

  self.icon = {
    url: self.el.find('.map').attr('data-pin'),
    size: new google.maps.Size(190, 166),
    origin: new google.maps.Point(0, 0),
    anchor: new google.maps.Point(47, 71),
    scaledSize: new google.maps.Size(95, 83),
  }

  self.initMap = function () {
    self.location = {
      lat: parseFloat(self.el.find('.map').attr('data-lat')),
      lng: parseFloat(self.el.find('.map').attr('data-lng')),
    }

    const mapElement = self.el.find('.map-canvas').get(0);
    
    // Track map load
    self.optimizer.trackMapLoad();
    self.map = new google.maps.Map(mapElement, {
      center: self.location,
      zoom: 12,
      maxZoom: 18,
      disableDefaultUI: true,
    })

    self.marker = new google.maps.Marker({
      position: self.location,
      map: self.map,
      icon: self.icon,
    })

    self.bindEventHandlers();
  }

  self.bindEventHandlers = function() {
    self.el.find('.contact-park').click(function (event) {
      event.preventDefault()
      $(this).hide()

      self.el.find('.form-container').slideDown()
    })

    self.el.find('.cancel-enquiry-button').click(function (event) {
      event.preventDefault()
      self.el.find('.form-container').slideUp()
      self.el.find('.contact-park').show()
    })

    // when generated google map is clicked,
    // open new tab with selected park pinned
    self.el.find('.map').click(function (event) {
      event.preventDefault()
      self.el.find('.google-map-link')[0].click()
    })
  }

  self.init = function () {
    if (process.env.NODE_ENV === 'development') {
      console.log('TabParkInfo init', self)
    }
    self.el.css('opacity', 1)
    self.initMap()

    if (self.formContainer.attr('data-park-form-recipient')) {
      self.formContainer.find('input[type=hidden]').each(function () {
        if ($(this).attr('name').indexOf('Recipient.Value') > -1) {
          $(this).val(self.formContainer.attr('data-park-form-recipient'))
          return false
        }
      })
    }

    if (self.formContainer.attr('data-park-form-title')) {
      self.formContainer.find('input[type=hidden]').each(function () {
        if ($(this).attr('name').indexOf('ParkTitle.Value') > -1) {
          $(this).val(self.formContainer.attr('data-park-form-title'))
          return false
        }
      })
    }

    self.el.find('.contact-accordion .header').click(function (event) {
      event.preventDefault()

      self.el.find('.contact-accordion').toggleClass('expanded')

      if (self.el.find('.contact-accordion').hasClass('expanded')) {
        $(this).parents('.contact-accordion').find('.content').slideDown()
      } else {
        $(this).parents('.contact-accordion').find('.content').slideUp()
      }
    })
  }
}
